import React from "react";
import { Row, Col, Button } from "reactstrap";
//import { getFullPath } from "../MyProfile/index";
import { Form } from "reactstrap";
import { connect } from "react-redux";
import { removeGuardianByGuardianId } from "./redux/action";
import {
  setNavigationParams,
  showPasswordOverlay,
} from "../../global/redux/action";

//import className from "classnames";
import { FaTrash } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import { showModal } from "../../global/redux/action";

import FootprintImage from "../../global/utils/FootprintImage";
class guardianItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { item } = this.props;
    return (
      <Row
        className="border-0 shadow card"
        style={{
          display: "flex",
          flexDirection: "row",
          padding: "1.5rem",
          marginBottom: "10px",
        }}
      >
        <span>
          <FootprintImage
            imageStyles={{ borderRadius: 500, marginBottom: 5 }}
            imageUrl={item.guardian_picture}
          />

          {item.status !== "Active" && (
            <p
              className=" text-center"
              style={{
                color: "red",
                fontSize: 12,
              }}
            >
              {item.status}
            </p>
          )}
        </span>
        <Col style={{ lineHeight: "30px" }}>
          <Form style={{ fontSize: "0.9rem" }}>
            <span style={{ fontWeight: "bold" }}>Name : </span>
            <span> {item.guardian_name}</span>
            <Col></Col>
            <span style={{ fontWeight: "bold" }}>Relation : </span>{" "}
            <span> {item.relation_to_child}</span>
            <Col></Col>
            <span style={{ fontWeight: "bold" }}>Mobile Number : </span>{" "}
            <span>{item.guardian_mobile_no} </span>
            <Col></Col>
          </Form>
        </Col>
        {item.isEditable !== false && (
          <div style={{ lineHeight: "30px", display: "inline" }}>
            <Button
              onClick={() => {
                this.props.setNavigationParams(item);
                this.props.history.push({
                  pathname: "addGuardian",
                  item: item,
                });
              }}
            >
              <MdModeEdit style={{ fontSize: "1em", color: "#19ade4" }} />
              Edit
            </Button>
            <Button
              onClick={() => {
                // alert(item.guardian_id);
                this.props.showModal(
                  "Success",
                  "Are You Sure You Want To Remove " + item.guardian_name + "?",
                  true,
                  () => {
                    this.props.showPasswordOverlay(true, (isMatched) => {
                      if (isMatched) {
                        this.props.removeGuardianByGuardianId(item.guardian_id);
                      }
                    });
                  },
                  () => { }
                );
              }}
            >
              <FaTrash style={{ fontSize: "1em", color: "red" }} />
              Delete
            </Button>
          </div>
        )}
      </Row>
    );
  }
}

//export default guardianItem;
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setNavigationParams: (params) => dispatch(setNavigationParams(params)),
  removeGuardianByGuardianId: (guardianId) =>
    dispatch(removeGuardianByGuardianId(guardianId)),
  showModal: (type, message, isConfirm, onOkPressed, onCancelPressed) =>
    dispatch(showModal(type, message, isConfirm, onOkPressed, onCancelPressed)),
  showPasswordOverlay: (show, onSuccess) =>
    dispatch(showPasswordOverlay(show, onSuccess)),
});
export default connect(mapStateToProps, mapDispatchToProps)(guardianItem);
